import { useEffect } from 'react';
import { useLocation } from 'wouter';
import { useProductTour } from './ProductTourProvider';
import { useAuth } from '@/hooks/useAuth';

const WELCOME_SHOWN_KEY = 'limephone-welcome-triggered';

export function TourTrigger() {
  const [location] = useLocation();
  const { user } = useAuth();
  const { tourState, isFirstVisit, setShowWelcomeModal, startTour } = useProductTour();

  useEffect(() => {
    if (!user) return;
    if (!isFirstVisit) return;
    if (tourState.hasSkippedTour || tourState.hasCompletedMainTour) return;

    const alreadyShown = localStorage.getItem(WELCOME_SHOWN_KEY) === 'true';
    if (alreadyShown) return;

    const dashboardPaths = ['/dashboard', '/inbox', '/textinbox'];
    if (dashboardPaths.some(p => location === p || location.startsWith(p + '/'))) {
      localStorage.setItem(WELCOME_SHOWN_KEY, 'true');
      setTimeout(() => {
        setShowWelcomeModal(true);
      }, 1500);
    }
  }, [location, isFirstVisit, tourState, setShowWelcomeModal, user]);

  useEffect(() => {
    if (!user) return;
    if (!tourState.hasCompletedMainTour) return;
    if (tourState.hasCompletedInboxTour || tourState.hasSkippedTour) return;

    const inboxPaths = ['/inbox', '/textinbox'];
    if (inboxPaths.some(p => location === p || location.startsWith(p + '/'))) {
      setTimeout(() => {
        startTour('inbox');
      }, 1000);
    }
  }, [location, tourState.hasCompletedMainTour, tourState.hasCompletedInboxTour, tourState.hasSkippedTour, startTour, user]);

  useEffect(() => {
    if (!user) return;
    if (!tourState.hasCompletedMainTour) return;
    if (tourState.hasCompletedDashboardTour || tourState.hasSkippedTour) return;

    if (location === '/dashboard') {
      setTimeout(() => {
        startTour('dashboard');
      }, 1000);
    }
  }, [location, tourState.hasCompletedMainTour, tourState.hasCompletedDashboardTour, tourState.hasSkippedTour, startTour, user]);

  return null;
}
